module.exports = __webpack_public_path__ + "static/media/logo-DIP.255557d3.svg";